import { MainContentArea, ContentHeader } from "melco-ui";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { useLog } from "../../hooks/logs/useLog";
import { LogJobsList } from "../../components/logs/LogJobsList";

export const LogDetails: React.FC = () => {
  const breadcrumb = useBreadcrumb("logs");

  const { logId } = useParams<{
    logId: string;
  }>();

  const { data: log } = useLog(logId!);

  return (
    <MainContentArea
      header={<ContentHeader title={log?.id ?? ""} breadcrumb={breadcrumb} />}
    >
      {log && <LogJobsList log={log} />}
    </MainContentArea>
  );
};
